<template>
    <div>
        <SingleFieldBarChart
                             :chart_config="chart_config"
                             :extent_id="extent_id"
                             :height="chart_height"
                             :width="chart_width"
                             click_callback="callback"
                             @callback="callback($event)"
                             :sticky_click="true"
        />
    </div>
    
</template>

<script>
    export default {
        name: "ReportCompVisualFilter",
        props: ['chart_config','extent_id','chart_height','chart_width'],
        data() {
            return {
                some_var: null,
            }
        },
        methods: {
          callback(payload) {
            this.$emit('addedFilters', payload)
          }
        },
    }
</script>
